import TextField from "../TextField/TextField";

interface NoteFieldProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  maxLength?: number;
}

/**
 * A controlled free-text field.
 *
 * TextField declares `textFieldValue`/`setTextFieldValue` but never reads them
 * — it is uncontrolled unless given react-hook-form's `field`, which it spreads
 * onto the MUI input. So we hand-build the same `{name, value, onChange}` shape
 * rather than reaching for the props that look right but do nothing.
 */
function NoteField(props: NoteFieldProps) {
  const { value, onChange, label, placeholder, maxLength = 200 } = props;

  return (
    <TextField
      id="order-note"
      label={label}
      placeholder={placeholder}
      type="text-area"
      multiline
      field={{
        name: "order-note",
        value,
        onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
          onChange(event.target.value.slice(0, maxLength)),
      }}
    />
  );
}

export default NoteField;
